<template>
    <div>
        <el-table
            :data="test"
            style="width: 100%"
            height="500"
            border
        >
            <el-table-column
                prop="attrName"
                align="center"
                label="属性名">
<!--                <template scope="scope">-->
<!--                    <span>{{scope.row.attrName}}</span>-->
<!--                </template>-->
                <template>
                    <span>默认</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="attrValue"
                align="center"
                label="属性值">
<!--                <template scope="scope">-->
<!--                    <span>{{scope.row.attrValue}}</span>-->
<!--                </template>-->
                <template>
                    <span>默认</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    import eventBus from '@/api/eventBus';
    export default {
        data(){
            return{
                skuList: [],
                skuValueList: [],
                attributes: [],
                test:[{attrName:"",attrValue:""}]
            }
        },
        created() {
            eventBus.$on('skuEdit',(res)=>{
                this.skuList = res.skuList;
                this.skuValueList = res.skuValueList;
                this.initialization();
            })
        },
        methods:{
            initialization(){
                this.attributes = [];
                this.skuList.forEach((item)=>{
                    for (const valueKvItem of item.valueKvList) {
                        this.attributes.push({
                            attrName: item.skuNameKv.kvName,
                            attrValue: valueKvItem.kvName,
                            attrSeq: null,
                        })
                    }
                })
            }
        }
    }
</script>
<style>

</style>